// stores/currentProduct.ts
export const useCurrentProductStore = defineStore('currentProduct', () => {
  const productData = ref(null)
  return { productData }
})